import * as React from 'react'
import { makeStyles } from '@mui/styles'
import LeftSideMenu from './LeftSideMenu'
import TicketsTable from './TicketsTable'
import MobileTicketsTable from './components/MobileTicketsTable'
import MobileMenu from './components/MobileMenu'
import AnimatedBurgerIcon from './components/AnimatedBurgerIcon'
import useMobile from './hooks/useMobile'

const useStyles = makeStyles((theme) => ({
    mainDiv: {
        display: 'flex',
        height: '100%',
    },
}))

const Tickets = (props) => {
    const classes = useStyles()
    const { isMobile } = useMobile()
    const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false)

    return (
        <div className={classes.mainDiv}>
            {/* Мобильная версия */}
            {isMobile ? (
                <div style={{ 
                    width: '100%',
                    height: '100vh',
                    padding: '0',
                    background: 'var(--black)',
                    overflow: 'hidden'
                }}>
                    {/* Мобильная навигация */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: 'var(--spacing-md)',
                        background: 'var(--dark-gray)',
                        borderBottom: '1px solid var(--light-gray)',
                        position: 'sticky',
                        top: 0,
                        zIndex: 100
                    }}>
                        <AnimatedBurgerIcon
                            isOpen={mobileMenuOpen}
                            onClick={() => setMobileMenuOpen(true)}
                        />
                        <h1 style={{ 
                            margin: 0,
                            fontWeight: 600,
                            fontSize: 'var(--text-lg)',
                            background: 'var(--gradient-orange)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text'
                        }}>
                            Tickets
                        </h1>
                        <div style={{ width: '32px' }} /> {/* Spacer for centering */}
                    </div>

                    {/* Мобильное меню */}
                    <MobileMenu 
                        user={props.user} 
                        active={props.active} 
                        apiClient={props.apiClient}
                        isOpen={mobileMenuOpen}
                        onClose={() => setMobileMenuOpen(false)}
                    />
                    
                    {/* Контент */}
                    <div style={{
                        height: 'calc(100vh - 60px)',
                        overflow: 'auto',
                        padding: 'var(--spacing-sm)',
                        width: '100%'
                    }}>
                        <MobileTicketsTable apiClient={props.apiClient}/>
                    </div>
                </div>
            ) : (
                /* Десктопная версия */
                <>
                    <LeftSideMenu active={props.active} user={props.user} apiClient={props.apiClient}/>
                    <TicketsTable apiClient={props.apiClient}/>
                </>
            )}
        </div>
    )
}

export default Tickets